import { rIC } from "../../utils";

function b2bPredictiveSearchController() {
  // Only initialise if the markup exists in DOM (i.e. the buyer is B2B)
  if (document.querySelector('form[is="b2b-predictive-search"]')) {
    void import("./b2b-predictive-search");
  }
}

const index = () => rIC(b2bPredictiveSearchController);
export default index;
